import React from 'react';

const PublicAnamnesePageTest = () => {
  return (
    <div style={{ 
      padding: '50px', 
      backgroundColor: 'yellow', 
      minHeight: '100vh',
      fontSize: '24px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ color: 'red' }}>🧪 TESTE BÁSICO - SE VOCÊ VÊ ISSO, A ROTA FUNCIONA!</h1>
      <p>Se esta página aparece, o problema não é com a rota React.</p>
      <p>Próximo passo: testar conexão com backend.</p>
    </div>
  );
};

export default PublicAnamnesePageTest;
